import styled from 'styled-components';

export const Content = styled.div`
  width: 100%;
`;

/* The card's own body. The scrollbar and the private scroll container that
   used to live here are gone — the shell's content area scrolls. */
export const Body = styled.div`
  width: 100%;
`;

/**
 * The fields column and the uploader beside it.
 *
 * It used to be one of two equal columns, with the image uploader sitting
 * above the Arabic title in the second — which is why the two title labels sat
 * at different heights and the fields did not line up. The titles are now a
 * FieldPair and the uploader is a sibling, as drawn.
 *
 * The `input[name='ar-title'] { direction: rtl }` rule that used to live here
 * is gone: the control takes `dir="rtl"` now, which also gives it --font-ar.
 */
export const FormHeaderContainer = styled.div`
  display: flex;
  align-items: flex-start;
  gap: var(--s5);
  width: 100%;

  @media (max-width: 1100px) {
    flex-direction: column-reverse;
    align-items: stretch;
  }
`;

export const FormHeader = styled.div`
  display: flex;
  align-items: stretch;
  flex-direction: column;
  gap: var(--s4);
  flex: 1;
  min-width: 0;
`;

export const Uploader = styled.div`
  flex: 0 0 auto;
`;

/** The uploader had no label; every other control in the card has one. */
export const UploaderLabel = styled.label`
  display: block;
  margin-bottom: 6px;
  font-family: var(--font-ui);
  font-size: var(--fs-label);
  font-weight: var(--fw-medium);
  line-height: var(--lh-body);
  color: var(--text-muted);
`;
